// this is to look up the name of the form to the marketo form id

export const MarketoFormMap = {
  partnershipsForm: 1337,
  marketingForm: 1335,
  prMediaForm: 1338,
  landlordForm: 1156,
  eventSpaceForm: 1340,
  otherForm: 1339,
  bookTourForm: 1124,
  brokerForm: 1127,
  newsLetterForm: 1719,
  resourceForm: 1103,
  scheduleCallForm: 1124,
  getStarted: 1842,
  Q42021Reengagement: 1852,
  Corenet_Form: 1857,
  LandLordVip_Form: 1864,
};
